import assets from './referenceAssets.json'

// 静态展示素材独立于账户、支付、奖励等真实业务数据。
export function referenceAsset(page, key) {
  const path = assets[page]?.[String(key)]
  return path ? `${import.meta.env.BASE_URL}${path.replace(/^\//, '')}` : ''
}

export const gamePresentations = {
  '/game/sport': { key:'sport-main', title:22, artwork:[18,19,20], width:800, height:660, symbols:23, description:'业界赔率最佳、赛事最全，涵盖海量热门体育赛事，提供视频直播、专业体育数据统计，满足对体育赛事的一切需求！' },
  '/game/realbet': { key:'realbet', title:25, artwork:[16,17,18,19,20,21], width:700, height:750, symbols:26, description:'开云真人视讯为开云集团官方直营，最美荷官在线互动，带您玩转百家乐、骰宝、轮盘、牛牛、炸金花等多款真人视讯游戏，国际标准、公平公正，极致享受尽在开云真人。' },
  '/game/chess': { key:'chess', title:22, artwork:[16,17,18,19,20], width:750, height:700, description:'开云集团官方直营，热门棋牌品类丰富，聆听悦耳音乐，感受非同凡响极致体验，让游戏改变生活，尽在开云棋牌。' },
  '/game/gaming': { key:'gaming', title:26, artwork:[16,19,22], width:700, height:750, symbols:27, description:'创新电竞竞猜模式，实时滚球，独创自由串关。注单秒确认，热门赛事秒结算，独家滚球助您嗨翻全场。绝妙畅爽体验，一切竞有可能！' },
  '/game/lottery': { key:'lottery', title:27, artwork:[17,19,21,23], width:750, height:700, symbols:28, description:'开云彩票为您提供最便捷丰富的彩票新玩法，精彩绝伦的交互体验，连线开彩最即时，业界彩种最丰富，开启彩票新纪元。' },
  '/game/egame': { key:'egame', title:17, artwork:[19], arcade:true },
  '/game/fishing': { key:'fishing', title:17, artwork:[19], arcade:true },
}

export const headerArtwork = { customer:1, agent:2, sponsor:3, promotion:4, app:5, deposit:6, transfer:8, withdraw:10 }
export const memberArtwork = {
  '/member':[23,24], '/mine/vip':[25,26], '/mine/record/welfare':[27,28],
  '/member/balance-treasure':[29,30], '/mine/rebate':[31,32], '/mine/finance/wallet':[33,34],
  '/mine/record/transRecord':[35,36], '/mine/record/betRecord':[37,38], '/mine/record/giftRecord':[39,40],
  '/mine/messages':[41,42], '/mine/feedback':[43,44], '/help/center':[45,46],
}
